// https://date-fns.org/docs/format
import format from 'date-fns/format'
import differenceInMinutes from 'date-fns/differenceInMinutes'
import { parseStringToDateTime } from '@utils/parse-string-to-date'
import { calendar } from '@utils/format-lunar'

import store from '@state/store'
import { zhTW, enUS } from 'date-fns/locale'

const localeMap = {
  'zh-hant': zhTW,
  en: enUS,
};

export default function formatDate(date, pattern = 'date') {
  if(!date) {
    return 'null date'
  }

  if (!(date instanceof Date)) {
    date = parseStringToDateTime(date)
  }
  const patterMap = {
    date: 'yyyy-MM-dd', // '2019-06-13'
    dateSlash: 'yyyy/MM/dd', // '2019/06/13'
    month: 'yyyy-MM', // '2019-06'
    year: 'yyyy', // '2019'
    dateTime: 'yyyy/MM/dd HH:mm', // 2019-01-01 00:00
    dateTimeSecond: 'yyyy-MM-dd HH:mm:ss', // 2019-01-01 00:00:00
    dateWeekDay: 'yyyy/M/d EEE', // '2019/6/13 週三'
    dateTimeWeekDay: 'yyyy/M/d EEE HH:mm', // '2019/6/13 週三 00:00'
    time: 'HH:mm', // '13:30',
    monthText: 'yyyy年M月', // '2019年6月'
    dateText: 'yyyy年M月d日', // '2019年6月3日'
  };

  return format(date, patterMap[pattern], {
    locale: localeMap[store.state.set.cachedLanguage],
  })
}


export function formatLunar(date, type) {
  const dateTime = parseStringToDateTime(date);

  const year = dateTime.getFullYear();
  const month = dateTime.getMonth() + 1;
  const day = dateTime.getDate();

  const { gzYear, Animal, IMonthCn, IDayCn } = calendar.solar2lunar(year, month, day);

  switch (type) {
    case 'lunar':
      return `(農曆${IMonthCn}${IDayCn})`;
    case 'dateLunar':
      return `${day}日 (農曆${IMonthCn}${IDayCn})`;
    case 'birth':
      return `農曆生辰${gzYear} 肖${Animal} ${IMonthCn}${IDayCn}`;
    case 'order-birth':
      return `${gzYear}肖${Animal} ${IMonthCn}${IDayCn}`;
    default:
      return `${year} ${gzYear}肖${Animal} (民國${year - 1911}年)`;
  }
}

export function timeDiffInMinutes(startTime, endTime) {
  const startDate = parseStringToDateTime(`2018-01-01 ${startTime}`);
  const endDate = parseStringToDateTime(`2018-01-01 ${endTime}`);

  return differenceInMinutes(endDate, startDate)
}

export function dateDiffInMinutes(startDate, endDate) {
  startDate = parseStringToDateTime(startDate);
  endDate = parseStringToDateTime(endDate);

  return differenceInMinutes(endDate, startDate)
}
